import HeaderSkeleton from "../ordering/HeaderSkeleton";
import HeaderShipment from "../ordering/HeaderShipment";
import {useState} from "react";
import {shipmentService} from "../../../../res/dataServices/shipmentService";
import useShipments from "../../../state/ordering/useShipments";
import {idempiereDate} from "../../../../res/dataServices/idempiereDate";
import RangeSelector from "../../../account/component/RangeSelector";

const DEFAULT_MONTHS = 12;
const DEFAULT_DATE = idempiereDate.getXMonthsAgo(DEFAULT_MONTHS);
const DEFAULT_START = "'" + idempiereDate.getDateString(DEFAULT_DATE) + "'";
const DEFAULT_END = "'" + idempiereDate.getDateString(new Date()) + "'"
const DEFAULT_LIMIT = 10;

const AccountLayoutShipments = () => {

    const [ reloaded, setReloaded ] = useState(false);

    const {
        activeShipments,
        ordering,
        loading,
        fetchedDates,
        getShipmentsByDate,
        getActiveShipments
    } = useShipments();

    if(!reloaded) {
        setReloaded(true);
        getShipmentsByDate(DEFAULT_START, DEFAULT_END, DEFAULT_LIMIT);
        getActiveShipments();
    }

    const showLoading = loading.shipments || loading.activeShipments
        || !ordering.shipments || !activeShipments;

    const deliveredList = ordering.shipments ? Object.values(ordering.shipments) : [];
    const dispatchedList = activeShipments ? activeShipments.shipments : [];

    console.log(deliveredList);
    //deliveredList.sort((a,b) => b.created - a.id);
    deliveredList.sort((a,b) => idempiereDate.compareDates(b.Created, a.Created));

    const displayList = (list) => {
        return !showLoading && list.length > 0;
    }

    const findInLinks = (name, id) => {
        if(ordering[name] && ordering[name][id]) {
            return ordering[name][id];
        } else if(activeShipments[name] && activeShipments[name][id]) {
            return activeShipments[name][id];
        }
    }
    const getLinkedOrders = (shipment) => {
        const { orderIDs } = shipmentService.getLinkedIDs(shipment);
        const orders = [];
        for(const id of orderIDs) {
            const order = findInLinks("orders", id)
            if(order) orders.push(order);
        }
        return orders;
    }
    const getLinkedInvoices = (shipment) => {
        const { invoiceIDs } = shipmentService.getLinkedIDs(shipment);
        const invoices = [];
        for(const id of invoiceIDs) {
            const invoice = findInLinks("invoices", id)
            if(invoice) invoices.push(invoice);
        }
        return invoices;
    }

    const onRangeRequest = (startDate, endDate) => {
        if(!showLoading) {

            const idStartDate = `'${idempiereDate.getDateString(startDate)}'`;
            const idEndDate   = `'${idempiereDate.getDateString(endDate)}'`;

            if(!fetchedDates || !(fetchedDates.startDate === idStartDate && fetchedDates.endDate)) {
                getShipmentsByDate(idStartDate, idEndDate);
            }
        }
    }


    return (
        <>
            <h1>Shipments</h1>
            <RangeSelector
                maxDates={DEFAULT_MONTHS}
                buttonText="Load Shipments"
                loading={showLoading}
                onRequest={onRangeRequest}
            />
            {showLoading &&
                <div className="account-view-list">
                    {[...Array(4).keys()].map((e,i) =>
                        <HeaderSkeleton v key={i} />
                    )}
                </div>
            }
            {displayList(dispatchedList) &&
                <div className="account-view-list">
                    <p className="account-heading-large">Out for delivery</p>
                    {dispatchedList.map((e,i) =>
                        <HeaderShipment
                            key={i}
                            shipment={e}
                            orders={getLinkedOrders(e)}
                            invoices={getLinkedInvoices(e)}
                        />
                    )}
                </div>
            }
            {displayList(deliveredList) ?
                <div className="account-view-list">
                    <p className="account-heading-large">Shipments</p>
                    {deliveredList.map((e,i) =>
                        <HeaderShipment
                            key={i}
                            shipment={e}
                            orders={getLinkedOrders(e)}
                            invoices={getLinkedInvoices(e)}
                        />
                    )}
                </div> :
                <div className="account-view-list">
                    <p className="account-heading-large">Shipments</p>
                    {!showLoading &&
                        <>
                            Sorry! No shipments could be found for the given date range!
                        </>
                    }
                </div>
            }
        </>
    )

}

export default AccountLayoutShipments;
